var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', {
    staticClass: "setting_c"
  }, [_c('li', {
    staticClass: "fontSize"
  }, [_c('span', [_vm._v("字号")]), _vm._v(" "), _c('div', _vm._l((_vm.fontSize), function(size, index) {
    return _c('span', {
      key: size.content,
      class: {
        on: index == _vm.defaultSize
      },
      on: {
        "click": function($event) {
          _vm.setSize(index)
        }
      }
    }, [_vm._v(_vm._s(size.content))])
  }))]), _vm._v(" "), _c('li', {
    staticClass: "bg"
  }, [_c('span', [_vm._v("背景")]), _vm._v(" "), _c('div', _vm._l((_vm.bg), function(bgc, index) {
    return _c('span', {
      key: bgc,
      style: ({
        'background-color': bgc
      }),
      on: {
        "click": function($event) {
          _vm.setBg(index)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.defaultBg),
        expression: "index == defaultBg"
      }]
    }, [_vm._v("√")])])
  }))]), _vm._v(" "), _c('li', {
    staticClass: "night"
  }, [_c('span', [_vm._v("夜间")]), _vm._v(" "), _c('div', {
    class: {
      on: _vm.night
    },
    on: {
      "click": _vm.setNight
    }
  }, [_vm._v("\n          开关\n        ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-65069960","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/setting.vue
// module id = JGBW
// module chunks = 1